import React, { Component } from 'react';
import { Tabs, Card } from 'antd';

import { BackBtn } from '@comm/BackBtn';
import moment from 'moment';
import DateCondition from '@comm/search/DateSearch';
import { connect } from 'react-redux';
import { getExpendType } from '@store/modules/finance/expend_type';
import { getIncomeType } from '@store/modules/finance/income_type';
import TabDetail from './TabDetail';
import TabChart from './TabChart';
import '../analyze.less';

const { TabPane } = Tabs;
const currentYear = moment.unix(new Date().getTime() / 1000).format('YYYY');
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      condition: {
        beginDate: `${currentYear}-01-01`,
        endDate: `${currentYear}-12-31`,
      },
    };
  }

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(getExpendType()); // 资金流水列表需要类目
    dispatch(getIncomeType());
  }

  handleChange = params => {
    this.setState({
      condition: { ...params },
    });
  };

  render() {
    const { condition } = this.state;
    return (
      <div>
        <BackBtn />
        <Tabs
          defaultActiveKey="1"
          onChange={this.callback}
          tabBarExtraContent={
            <DateCondition onChange={this.handleChange} defaultValue={this.state.condition} />
          }
        >
          <TabPane tab="总支出" key="1">
            <Card>
              <TabChart {...this.props} condition={condition} />
            </Card>
          </TabPane>
          <TabPane tab="详情" key="2">
            <TabDetail {...this.props} condition={condition} />
          </TabPane>
        </Tabs>
      </div>
    );
  }
}
export default connect(state => ({
  expendType: state.expend_type,
  incomeType: state.income_type,
}))(Index);



// WEBPACK FOOTER //
// ./src/components/incubator/analyze/expend/Index.js